const regenerateRule = (initialRule, newRuleMap) => {
  const final = initialRule.replace(/[A-Z]+/g, (match) => newRuleMap[match]);
  return final;
};

export default regenerateRule;
